import instanceQuery from 'graphql/queries/nominal/NominalConfigQuery.graphql';
import dimensionQuery from 'graphql/queries/nominal/NominalConfigDimensions.graphql';
import defaultQuery from 'graphql/queries/nominal/NominalConfigDefault.graphql';
import mutationQuery from 'graphql/mutations/nominal/NominalConfigMutation.graphql';
import fragment from 'graphql/fragments/nominal/NominalConfigFragment.graphql';
import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';

const NominalConfig = {
  type: 'NominalConfig',
  title: 'Nominal Configuration',
  formTitle: 'Nominal Configuration',
  formUrl: '/Nominal/NominalConfig/',
  instance: instanceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dimensions: dimensionQuery,
  fragment,
  screenReference: 'NOMINAL_CONFIGURATION',
  operations: ALLOW_EDIT | ALLOW_VIEW,
};

export default NominalConfig;
